import styled from '@emotion/styled'
import { InfoSmall500Style } from '../../../../../styles/Text.styles'

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: 6rem 12rem;
  grid-template-rows: auto auto;
  column-gap: 10px;
  row-gap: 5px;
  justify-content: end;
  width: 99%;
  margin-top: 1rem;
  row-gap: 0.7rem;
`

export const ErrorSectionContainer = styled.div``

export const FlowRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 1rem;
`

export const NoteText = styled.div`
  ${InfoSmall500Style}
  grid-column: 2;
`
